import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'PositionAndDirection',
  field: 'Geometry',
  weeks: [9, 10],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      smallStep: 'LanguageOfPosition',
      questionTypes: ['blx', 'bly', 'blz'],
      archivedQuestionTypes: [],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Summer/PositionAndDirection/1LanguageOfPosition" */ './1LanguageOfPositionModels'
        )
    }),
    // Step 2
    newSmallStepContent({
      smallStep: 'DescribeMovement',
      questionTypes: ['blA', 'blB', 'blC'],
      archivedQuestionTypes: [],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Summer/PositionAndDirection/2DescribeMovement" */ './2DescribeMovementModels'
        )
    }),
    // Step 3
    newSmallStepContent({
      smallStep: 'DescribeTurns',
      questionTypes: ['blD', 'blE', 'blF'],
      archivedQuestionTypes: [],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Summer/PositionAndDirection/3DescribeTurns" */ './3DescribeTurnsModels'
        )
    }),
    // Step 4
    newSmallStepContent({
      smallStep: 'DescribeMovementAndTurns',
      questionTypes: ['blG', 'blH', 'blI'],
      archivedQuestionTypes: [],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Summer/PositionAndDirection/4DescribeMovementAndTurns" */ './4DescribeMovementAndTurnsModels'
        )
    }),
    // Step 5
    newSmallStepContent({
      smallStep: 'ShapePatternsWithTurns',
      questionTypes: ['blJ', 'blK', 'blL'],
      archivedQuestionTypes: [],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Summer/PositionAndDirection/5ShapePatternsWithTurns" */ './5ShapePatternsWithTurnsModels'
        )
    })
  ]
});
export default Block;
